// Change this single value to switch environments across the app.
const ENV = "qa"; // "local" | "test" | "qa" | "prod"

const ENV_CONFIG = {
  local: {
    API_BASE_URL: "http://localhost:5001",
    SOCKET_URL: "http://3.133.11.98:5002",
  },
  test: {
    API_BASE_URL: "https://3nl9j8fti3.execute-api.us-east-2.amazonaws.com/test",
    SOCKET_URL: "https://devapi.wannabae.com:5443",
  },
  qa: {
    API_BASE_URL: "https://p08y9ui5n5.execute-api.us-east-2.amazonaws.com/test",
    SOCKET_URL: "https://qaapi.wannabae.com:5443",
  },
  prod: {
    API_BASE_URL: "https://backend.wannabae.com",
    SOCKET_URL: "https://api.wannabae.com:5443",
  },
};

export const { API_BASE_URL, SOCKET_URL } = ENV_CONFIG[ENV];

export const IMAGE_UPLOAD_URL = `${API_BASE_URL}/Profile/upload-image`;
